export function sizeIsNativeAd(size: number[]): boolean {
  return Array.isArray(size) && size[0] === 0 && size[1] === 0;
}

export function sizeIsAdnami(size: number[]): boolean {
  return Array.isArray(size) && size[0] === 1 && size[1] === 2;
}
